import { LLMHistoryResponseDTO } from "@dto/llm.dto";
import { API_URL } from "src/data/Api";
import { Log } from "src/service/log.service";
import { getApi } from "src/util/apiCalls";

export const chatAborter: { current?: AbortController; } = {};

export function getChatHistory() {
  const promise = getApi<LLMHistoryResponseDTO>(API_URL.LLM + '/history', chatAborter.current?.signal);
  promise.catch(reason => Log.error('Failed to get chat history!', reason));
  return promise;
}